import { createAction, handleActions } from 'redux-actions';
import { api } from "api";
import {initialize as initializeForm} from "redux-form";
import {NotificationManager} from "react-notifications";
import {push} from "react-router-redux";
import _ from "lodash";
import {reset} from 'redux-form';
import moment from 'moment';

const LOADER = 'LOADER_COLABORADORES';
const DATA = 'DATA_COLABORADORES';
const ITEM_DATA = 'ITEM_COLABORADORES';
const PAGE = 'PAGE_COLABORADORES';
const ORDERING = 'ORDERING_COLABORADORES';
const SEARCH = 'SEARCH_COLABORADORES';

// -----------------------------------
// Pure Actions
// -----------------------------------

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setData = data => ({
    type: DATA,
    data,
});

const setItem = item => ({
    type: ITEM_DATA,
    item,
});

const setPage = page => ({
    type: PAGE,
    page,
});

const setOrdering = ordering => ({
    type: ORDERING,
    ordering,
});

const setSearch = search => ({
    type: SEARCH,
    search,
});

// ------------------------------------
// Actions
// ------------------------------------

const listarCupones = (page = 1) => (dispatch, getStore) => {
    const resource = getStore().colaboradores;
    const params = { page };
    params.ordering = resource.ordering;
    params.search = resource.search;
    dispatch(setLoader(true));
    api.get('cupon/cupones_colaborador', params).then((response) => {
        dispatch(setData(response));
        dispatch(setPage(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const leerCupon = id => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${'cupon'}/${id}`).then((response) => {
        dispatch(setItem(response));
        dispatch(initializeForm('CuponForm', response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const enviarCupon = data => (dispatch) => {
    dispatch(setLoader(true));
    api.post('cupon/enviar_cupon', data).then(() => {
        NotificationManager.success('Correo enviado correctamente', 'Éxito', 3000);
        dispatch(cleanForm()); // Limpiar el formulario
    }).catch((error) => {
        let mensaje = "Error en el envio";
        if (error.detail) {
            mensaje = error.detail;
        }
        NotificationManager.error(mensaje, 'ERROR');
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const cleanForm = () => (dispatch) => {
    dispatch(initializeForm('EnviarCuponForm', {}));
};

const searchChange = search => (dispatch) => {
    dispatch(setSearch(search));
    dispatch(listarCupones());
};

const onSortChange = ordering => (dispatch, getStore) => {
    const sort = getStore().colaboradores.ordering;
    if (ordering === sort) {
        dispatch(setOrdering(`-${ordering}`));
    } else {
        dispatch(setOrdering(ordering));
    }
    dispatch(listarCupones());
};

export const actions = {
    listarCupones,
    leerCupon,
    searchChange,
    onSortChange,
    enviarCupon,
    cleanForm,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [ORDERING]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [SEARCH]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
};

export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    page: 1,
    ordering: '',
    search: '',
};

export default handleActions(reducers, initialState);
